import React from 'react';
import Button from '../components/Button/Button';
import './HomePage.css'; 
import logo from '../img/logo.png'; // Importe o logo

function HomePage() {
  return (
    <div className="homepage">
      {/* Adicionando o logo */}
      <img src={logo} alt="Logo Atento" className="homepage-logo" />

      <div className="button-container">
        <Button 
          label="Autenticação Integrada" 
          onClick={() => window.location.href = 'https://hcm19.sapsf.com/login?company=atentobras#/login'} 
         tooltip="Autentique-se com o login integrado"
        />
        <Button 
          label="Usuário e Senha" 
          onClick={() => window.location.href = 'https://a3uiw9goy.accounts.ondemand.com/saml2/idp/sso?sp=https://www.successfactors.com/atentobras&idp=a3uiw9goy.accounts.ondemand.com'} 
          tooltip="Faça login com seu usuário e senha"
        />
      </div>
    </div>
  );
}

export default HomePage;
